import Dialog from "../Dialog";

const DeleteDialog = ({ id = "modal-delete", title, message, itemName, onConfirm, item }) => {
  const onDelete = async () => {
    if (onConfirm && item) {
      await onConfirm(item);
    }
  };

  return (
    <Dialog id={id}>
      <div className="uk-modal-dialog uk-modal-body">
        <button
          className="uk-modal-close-default"
          type="button"
          uk-close="true"
        ></button>
        <h2 className="uk-modal-title">{title || "Delete"}</h2>
        <p>
          {message || `Are you sure you want to delete "${itemName || item?.name}"`}?
        </p>
        <p className="uk-text-right">
          <button
            className="uk-button hms-btn uk-modal-close uk-modal-delete-cancel"
            type="button"
          >
            Cancel
          </button>
          <button
            className="uk-button hms-btn hms-gray-btn"
            type="button"
            onClick={onDelete}
          >
            Delete
          </button>
        </p>
      </div>
    </Dialog>
  );
};

export default DeleteDialog;
